import { FC, useContext, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import ProjectPoolHeading from "../Projects/ProjectPoolHeading";
import cross from "../../assets/images/cross.svg";
import useStyles from "../Styles/ProjectModalStyles";
import { WithDrawGainsModalProps } from "../../interfaces";
import WalletContext from "../../store/Wallet/WalletContext";
// import { useHistory } from "react-router-dom";
import AlertContext from "../../store/Alert/AlertContext";
import { ChainFromNetworkId } from "../../store/Wallet/WalletFunction";
import SubscriptionContext from "../../store/Subscription/SubscriptionContext";
import { useAccount, useConfig } from "wagmi";
import { switchChain } from "@wagmi/core";
import { LowGasError } from "../../services/web3";

const WithDrawGainsModal: FC<WithDrawGainsModalProps> = ({
  open,
  setOpen,
  subscriptionId,
  address,
  amount,
  network,
  scVersion,
}) => {
  const theme = useTheme();
  const config = useConfig();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));

  const { withdrawGains } = useContext<any>(WalletContext);
  const { getUserSubscriptions } = useContext<any>(SubscriptionContext);
  const { address: account, chain } = useAccount();
  const { setAlert } = useContext<any>(AlertContext);
  const lockChainId = ChainFromNetworkId(network);
  const [inProgress, toggleInProgress] = useState(false);

  const classes = useStyles();
  // const history = useHistory();

  const handleWithDraw = async () => {
    toggleInProgress(true);
    if (!lockChainId) {
      toggleInProgress(false);
      setAlert("Unable to perform the action at the moment, please try again", "info");
      return
    }
    if (lockChainId !== chain?.id) {
      await switchChain(config, {
        chainId: lockChainId
      })
    }
    withdrawGains(lockChainId, address.toLowerCase(), subscriptionId, scVersion)
      .then((data: any) => {
        getUserSubscriptions();
        setOpen(false);
        toggleInProgress(false);
      })
      .catch((error: any) => {
        toggleInProgress(false);
      });
  };

  const handleClose = (event: any, reason?: any) => {
    if ((reason && reason === "backdropClick") || inProgress) return;
    setOpen(false);
  };

  return (
    <>
      <Box component="section">
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={classes.modalpages}
        >
          <Box
            ml={isActive ? "20px" : 7}
            my={isActive ? "20px" : 7}
            mr={isActive ? "20px" : 4}
            className="relative-box"
          >
            {!isActive && (
              <img
                src={cross}
                alt=""
                className="cross-icon"
                onClick={handleClose}
              />
            )}
            <ProjectPoolHeading title1="Withdraw" title2="GAINS" />
            <Box>
              <Typography variant="body1" className="c-text">
                You can withdraw your
                <Typography
                  color="primary"
                  className="fw-bold"
                  component="span"
                >
                  {" "}
                  {amount} GAINS,
                </Typography>{" "}
                on{" "}
                {address.substr(0, 4) +
                  "..." +
                  address.substr(address.length - 4, address.length)}
                .
              </Typography>
            </Box>
            <Box display="flex" flexDirection="column">
              <Box mt={isActive ? 3 : 5}>
                <Button
                  onClick={handleWithDraw}
                  variant="contained"
                  color="secondary"
                  className="responsive-btn"
                  disabled={!account || account?.toLowerCase() !== address.toLowerCase() || inProgress}
                >
                  {(account)
                    ? (account.toLowerCase() !== address.toLowerCase())
                      ? "Incorrect Wallet"
                      : (lockChainId !== chain?.id)
                        ? "Switch Network"
                        : (inProgress)
                          ? "Withdrawal in progress..."
                          : "Continue to Withdraw"
                    : "Connect wallet to withdraw"}
                </Button>
              </Box>
            </Box>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default WithDrawGainsModal;
